module.exports = __webpack_public_path__ + "img/1618.c8fee6cf.png";